import { IdentityService } from '../..'
import { logger } from '../../../../utils/common/logger'
import { DOMUtils } from '../../../../utils/dom'
import { AdDOM } from '../../../ads/ad'
import { AdRefreshDOM } from '../../../ads/ad'
import { AdEvents } from '../../../ads/ad/events'

interface ICommentAttr {
    key: string
    value: string
}

export interface IViafouraWidget {
    el: HTMLElement
    wrapper: string
    vfTag: string
    attrs: ICommentAttr[]
    insertAfterVfTag?: string[]
    adAttrs?: ICommentAttr[]

    handleAdSlotEvent(slotName: string): void
}

export class ViafouraWidget implements IViafouraWidget {
    public adAttrs: ICommentAttr[] = []
    public el: HTMLElement = undefined

    private adEvent: AdEvents = AdEvents.SLOT_ADDED
    private DOM = {
        attrs: {
            class: 'viafoura',
            mobileSize: 'data-comments-ad-size-mobile',
            ref: 'data-comments-ad-ref',
            size: 'data-comments-ad-size',
            target: 'data-comments-ad-target',
            viafouraAd: 'data-ad-comment'
        },
        classes: {
            adContainer: 'ad__inner__container'
        }
    }

    /**
     * Initialize the component and build the widget, if the target class wrapper exists
     *
     * @param wrapper
     * @param attrs
     * @param vfTag
     * @param insertAfterVfTag
     * @param adCount
     */
    public constructor(
        public wrapper: string,
        public attrs: ICommentAttr[],
        public vfTag: string,
        public insertAfterVfTag?: string[],
        public adCount = 1
    ) {
        this.loadWidget()
    }

    /**
     * Ad slot handler.  Will be fired when viafoura creates a new ad slot to be added to the widget.
     *
     * @param slotName
     */
    public handleAdSlotEvent(slotName: string): void {
        if (DOMUtils.idElementExists(`${slotName}`)) {
            // target the ad slot provided by viafoura
            const adwrapper = document.getElementById(`${slotName}`)

            // set the correct attributes on the wrapper
            for(const container of IdentityService.DOM.class.adContainers) {
                adwrapper.setAttribute(DOMUtils.attrs.class, `${container}`)
            }

            // create the ad element
            const ad = document.createElement('div')
            ad.setAttribute(AdDOM.attr.location.key, `${this.adCount}`)
            this.adAttrs.forEach((_: any) => {
                ad.setAttribute(_.key, _.value)
            })

            // append the ad element to the ad wrapper
            adwrapper.append(ad)

            logger('info', `added new ad slot for viafoura: ${slotName}, ad counter ${this.adCount}`)

            // fire an event for the new ad slot
            this.dispatchNewAdEvent(slotName)

            // increment the ad count for the next ad
            this.adCount = this.adCount + 1
        }
    }

    /**
     * Dispatch a javascript event indicating that a new ad slot was added
     */
    public dispatchNewAdEvent(slotName: string) {
        const el = DOMUtils.nodes(document.querySelector(`#${slotName} [${this.DOM.attrs.viafouraAd}]`))

        dispatchEvent(new CustomEvent(this.adEvent, {
            detail: {
                el
            }
        }))
    }

    /**
     * Load the initial widget into the DOM
     */
    private loadWidget() {
        this.el = document.querySelector(`[${this.wrapper}]`)

        // only construct the widget html if the element exists on the page
        if (this.el) {
            const widgetElement: HTMLElement = document.createElement('div')

            DOMUtils.addClass(widgetElement, this.DOM.attrs.class)

            const container = document.createElement(this.vfTag)

            this.attrs.forEach((_: any) => {
                container.setAttribute(_.key, _.value)
            })
            widgetElement.appendChild(container)

            if (this.insertAfterVfTag) {
                this.insertAfterVfTag.forEach((el) => {
                    widgetElement.appendChild(document.createElement(el))
                })
            }

            this.el.appendChild(widgetElement)

            this.initAdAttributes()

            logger('debug', `viafoura widget loaded for wrapper: ${this.wrapper} - appended to element as child`)
        } else {
            logger('debug', `viafoura widget not loaded for wrapper: ${this.wrapper} - wrapper not present`)
        }
    }

    /**
     * Set ad attributes to be used on the ad element
     */
    private initAdAttributes() {
        this.adAttrs = [
            {
                key: DOMUtils.attrs.class,
                value: this.DOM.classes.adContainer
            },
            {
                key: AdDOM.attr.target.key,
                value: this.el.getAttribute(this.DOM.attrs.target)
            },
            {
                key: AdDOM.attr.size.key,
                value: this.el.getAttribute(this.DOM.attrs.size)
            },
            {
                key: AdDOM.attr.mobileSize.key,
                value: this.el.getAttribute(this.DOM.attrs.mobileSize)
            },
            {
                key: AdRefreshDOM.attr.state.key,
                value: this.el.getAttribute(this.DOM.attrs.ref)
            },
            {
                key: `${this.DOM.attrs.viafouraAd}`,
                value: ''
            }
        ]
    }
}
